import { css } from 'emotion';

export default {
	consent_wrapper: css`
		display: flex;
	`,

	consent_check_box: css`
		margin-right: 12px;
	`,

	consent_label: css`
		margin-top: -1px;
	`,

	consent_label_lnk: css`
		margin-top: -1px;
		text-decoration: underline;
		cursor: pointer;
	`,

	consent_footer: css`
		font-size: xx-small;
	`,

	clear: css`
		clear: both;
	`,

	buttonsRow: css`
		display: flex;
		padding-top: 20px;
		padding-bottom: 20px;
		justify-content: flex-end;
		flex-direction: row;
	`
};



// WEBPACK FOOTER //
// ./src/components/Consent/styles.js